import { messageTypeTextMap } from './definitions'
import { PartFamily } from './types'

const getMessageTypeKey = (type: string, hasQuestion?: boolean): keyof typeof messageTypeTextMap => {
  if (type === PartFamily.WhatsAppFlow) {
    return 'whatsapp-f'
  }
  if (type === PartFamily.QuotaActions) {
    return 'quota-q'
  }

  return `${type}-${hasQuestion ? 'q' : 'm'}` as keyof typeof messageTypeTextMap
}

export const getMessagePlaceholderLabel = (type: string, hasQuestion?: boolean) =>
  messageTypeTextMap[getMessageTypeKey(type, hasQuestion)] || {
    label: 'Message',
    conditionsTitle: 'Send this message',
  }

export const formatMessageLabel = (index: number, label: string) => `${index + 1}. ${label}`
